import styled from 'styled-components';

export const SupplierProgressListMainWrap = styled.div(
  props => `
.suppliersProgressBar{
    width: 308px;
    flex-shrink: 0;
}

.suppliersProgressBar .progressOuter{
    height: 6px;
    background-color: #D8D8D8;
    border-radius: 100px;
    overflow: hidden;
}

.suppliersProgressBar .progressInner{
    height: 6px;
    background-color: #007E7D;
    border-radius: 100px;
    width: ${props.completionPercent}%;
}

.suppliersProgressBar .progressInner.w40pc{
    width: 40%;
}
.suppliersProgressBar .progressInner.w80pc{
    width: 80%;
}
.suppliersProgressBar .progressInner.w60pc{
    width: 60%;
}
.suppliersProgressBar .progressInner.w20pc{
    width: 20%;
}
.suppliersProgressBar .progressInner.w100pc{
    width: 100%;
}`,
);
